"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failed = exports.InUse = exports.Stopped = exports.Prepared = exports.NotSupported = exports.NotRequested = exports.NativeHlsGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const native_hls_1 = require("../../drivers/video-element/native-hls");
const state_flow_2 = require("../state-flow");
const common_1 = require("./common");
//#endregion
//#region Group Declaration
exports.NativeHlsGroup = state_flow_2.PlayerStateFlow.registerGroup("nativeHls").bootstrap(() => {
    return (0, exports.NotRequested)({
        driverFormat: "mp4-hls",
        priority: -1,
        support: "",
        timeout: 0,
        features: {
            sourceQuality: false,
            forcedQuality: true,
            autoBitrate: true,
        },
    });
});
//#endregion
//#region Signals Handlers
function loadDriver(groups, signal) {
    const [priority, config] = (0, common_1.findDriver)(native_hls_1.NativeHlsDriver, signal.options.drivers);
    if (priority === -1) {
        return state_flow_1.Result.ignore();
    }
    const support = (0, common_1.checkDriverSupport)(native_hls_1.NativeHlsDriver, groups.host.element, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.nativeHls, priority, support, timeout: config.timeout });
    }
    return (0, exports.NotSupported)({ ...groups.nativeHls, priority, support });
}
function unloadDriver(groups, signal) {
    const [priority, _] = (0, common_1.findDriver)(native_hls_1.NativeHlsDriver, signal.options.drivers);
    if (priority !== -1) {
        return state_flow_1.Result.ignore();
    }
    return (0, exports.NotRequested)({ ...groups.nativeHls, priority });
}
function updateSupportHostStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(native_hls_1.NativeHlsDriver, signal.host, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.nativeHls, support });
    }
    return (0, exports.NotSupported)({ ...groups.nativeHls, support });
}
function updateSupportManifestStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(native_hls_1.NativeHlsDriver, groups.host.element, signal.manifest);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.nativeHls, support });
    }
    return (0, exports.NotSupported)({ ...groups.nativeHls, support });
}
// function nativeHlsLoad({ nativeHls, manifest }: Groups, signal: Signals["nativeHlsLoad"]): StateResult<Props> {
//   const format = manifest.json?.formats[nativeHls.driverFormat];
//   if (format == null) {
//     return NotSupported({ ...nativeHls });
//   }
//
//   return Loaded({ ...nativeHls });
// }
// function requestDriver({ nativeHls }: Groups, signal: Signals["requestDriver"]): StateResult<Props> {
//   return NotSupported(nativeHls);
// }
//#endregion
//#region States Declarations
exports.NotRequested = exports.NativeHlsGroup.registerState("NotRequested", {
    optionsApply: loadDriver,
});
exports.NotSupported = exports.NativeHlsGroup.registerState("NotSupported", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
});
exports.Prepared = exports.NativeHlsGroup.registerState("Prepared", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.NativeHlsGroup.name ? (0, exports.InUse)(g.nativeHls) : g.nativeHls;
    },
});
exports.Stopped = exports.NativeHlsGroup.registerState("Stopped", {
    optionsApply: unloadDriver,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.NativeHlsGroup.name ? (0, exports.InUse)(g.nativeHls) : g.nativeHls;
    },
});
exports.InUse = exports.NativeHlsGroup.registerState("InUse", {
    optionsApply: () => state_flow_1.Result.reject("driver is in use"),
    hostElementDetach: () => state_flow_1.Result.reject("host element is in use of NativeHlsDriver"),
    // hostElementDetach: (g) => Prepared(g.nativeHls),
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.NativeHlsGroup.name ? g.nativeHls : (0, exports.Stopped)(g.nativeHls);
    },
});
exports.Failed = exports.NativeHlsGroup.registerState("Failed", {
    optionsApply: unloadDriver,
});
//#endregion
//# sourceMappingURL=native-hls.js.map